import { AbstractControl, ValidatorFn } from '@angular/forms';
import { FormStateService } from '@app/shared/components/form-builder/form-state.service';
import { isPresent } from '@app/shared/validators/extra-validators.module';

export const checkBudgetBalance = (formStateService: FormStateService): ValidatorFn => {

  function calculateLineSubtotal(total: number, entry: { type: string; quantity: number; unitPrice: number; rate: number; }): number {
    let subtotal: number;

    if (entry.type === 'AMOUNT') {
      subtotal = entry.quantity * entry.unitPrice;
    } else if (entry.type === 'RATE') {
      subtotal = entry.rate / 100 * total;
    }
    return total + subtotal;
  }

  return (_: AbstractControl): {[key: string]: boolean} => {
    const workCosts = formStateService.getPath(['costs', 'value', 'costs']);
    const workExpenses = formStateService.getPath(['expenses', 'value', 'expenses']);

    if (!isPresent(workCosts) || !isPresent(workExpenses)) {
      return null;
    }

    // Do reduce unitPrice * quantity on each line here
    const totalCost = workCosts.reduce(calculateLineSubtotal, 0);
    const totalExpenses = workExpenses.reduce(calculateLineSubtotal, 0);

    if (totalCost < totalExpenses) {
      return {
        lteTotalCosts: true,
        gteTotalExpenses: true
      };
    }
    return null;
  };
};
